const isUndefined = value => {
  if (!value || typeof value === 'undefined') {
    return true;
  }

  return false;
};

export { isUndefined };
